import { h as __h } from "preact";
import { Component } from "preact";
import { machineAccessInviteResponse } from "~/backend/validate.js";
import { query, response } from "~/lib/api.js";
import { acceptInvite, declineInvite } from "~/lib/machineAccess.js";
import html from "~/util/html.js";
import { PromiseSignal } from "~/util/promise.js";
import { array } from "~/util/validate.js";
import Avatar from "~/component/Avatar.js";
import Button from "~/component/Button.js";
import Data from "~/component/Data.js";
import Icon from "~/component/Icon.js";
import Popover from "~/component/Popover.js";
import Time from "~/component/Time.js";
import { adopt, importCss, CSS_MODULE_SCRIPTS } from "~/util/css.js";
const {
  default: sheet
} = CSS_MODULE_SCRIPTS ? await import("./ReceivedInvites.module.css", {
  with: {
    type: "css"
  }
}) : await importCss("./ReceivedInvites.module.css", import.meta.url);
const css = adopt(sheet);
export default class ReceivedInvites extends Component {
  invites = query(() => ({
    key: ["/v2/access-invites"]
  }), {
    schema: response(array(machineAccessInviteResponse))
  });
  render() {
    const invites = this.invites.data?.data;
    const pending = invites?.filter(invite => !invite.is_expired).length ?? 0;
    return __h(Popover, {
      id: "invites-popover",
      placement: "bottom-end",
      trigger: __h("span", {
        "class": css.trigger
      }, __h(Button, {
        type: "button",
        size: "small",
        popovertarget: "invites-popover"
      }, __h(Icon, {
        name: "users",
        size: 12
      }), __h("span", {}, "Invites"), pending > 0 && __h("span", {
        "class": css.badge
      }, pending)))
    }, __h("div", {
      "class": css.popover
    }, __h(Data, {
      loading: this.invites.loading && !invites,
      error: this.invites.error && __h("span", {
        "class": css.meta
      }, "Couldn't load your invites."),
      empty: !invites?.length && __h("span", {
        "class": css.meta
      }, "You haven't received any invites to someone else's computer.")
    }, __h("ul", {
      "class": css.list
    }, invites?.map(invite => __h(InviteRow, {
      key: invite.id,
      invite: invite
    }))))));
  }
}

/** @extends {Component<{ invite: machineAccessInviteResponse }>} */
class InviteRow extends Component {
  accept = new PromiseSignal(() => acceptInvite(this.props.invite));
  decline = new PromiseSignal(() => declineInvite(this.props.invite));
  render() {
    const {
      invite
    } = this.props;
    return __h("li", {
      "class": css.invite
    }, __h(Avatar, {
      name: invite.sender.name,
      size: 28
    }), __h("div", {
      "class": css.info
    }, __h("span", {}, __h("strong", {}, invite.sender.email), " invited you to ", __h("strong", {}, invite.machine.name)), __h("span", {
      "class": css.meta
    }, invite.is_expired ? "Expired" : ["Expires ", __h(Time, {
      datetime: new Date(invite.expires_at)
    })])), __h("div", {
      "class": css.actions
    }, !invite.is_expired && __h(Button, {
      size: "small",
      level: "primary",
      loading: this.accept.loading,
      disabled: this.decline.loading,
      onClick: () => this.accept.invoke()
    }, "Accept"), __h(Button, {
      size: "small",
      loading: this.decline.loading,
      disabled: this.accept.loading,
      onClick: () => this.decline.invoke()
    }, invite.is_expired ? "Delete" : "Decline")));
  }
}